// InsidersList
import React from 'react';
import { connect } from 'react-redux';

import ConnectedUserMenu from './ConnectedUserMenu';
import DomUserPicture from './DomUserPicture';
import { getTranslator } from '../locales';

@connect((Store) => {
  const t = getTranslator();

  const connectedUsersCount = Store.chat.connectedUsersCount;
  const insiders = Store.insiders.online

  return {
    labels: {
      PEOPLE_ON_THE_CHAT: t.t(
        '%{num_people} people on the chat',
        { num_people: connectedUsersCount , count: connectedUsersCount }
      ),
      INSIDERS_ONLINE: t.t(
        '%{num_insiders} Insiders Online',
        { num_insiders: insiders.length , count: insiders.length }
      )
    },
    luser: Store.luser,
    insiders,
    connectedUsersCount
  };
})

export default class InsidersList extends React.Component {
  render() {
    return (
      <div className={this.props.mobilePanelClassName('admin_activity')}>
        <ConnectedUserMenu
          mobilePanelChange={this.props.mobilePanelChange.bind(this)}
        />
        <div className='insiders'>
          {
            (() => {
              if (this.props.luser.insider){
                return <p className='connectedPeople'>
                  {this.props.labels.PEOPLE_ON_THE_CHAT}
                </p>
              }
            })()
          }

          <h3>{this.props.labels.INSIDERS_ONLINE}</h3>
          <ul>
            {
              Object.keys(this.props.insiders).map((userIndex, i) => {
                const user = this.props.insiders[userIndex];
                return (
                  <li id={i} key={i}>
                    <div className='picture'>
                      <DomUserPicture user={user} isInsider={true} size='s' />
                    </div>
                    <div className='identity'>
                      <strong>{user.name}</strong>
                      <em>{user.current_title}</em>
                    </div>
                    <div className='clear'></div>
                  </li>
                );
              })
            }
          </ul>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/UsersList.jsx